import { BasicLayout, RouteView } from '@/layouts'
import { Router } from './types'

export const example: Router = {
  path: '/',
  name: 'index',
  component: BasicLayout,
  meta: { title: 'menu.home' },
  redirect: '/shop',
  children: [
    {
      path: '/shop',
      name: 'shop',
      component: () => import('@/views/shop/shopMan/index.vue'),
      hideChildrenInMenu: true,
      meta: { title: 'menu.shop.title', icon: 'iconfont icon-31dianpu' }
    },
    {
      path: '/material',
      name: 'material',
      component: () => import('@/layouts/RouteView.vue'),
      redirect: '/material/article',
      meta: { title: 'menu.material.title', icon: 'iconfont icon-bianjiwenzhang_huaban' },
      children: [
        {
          path: '/material/article',
          name: 'materialArticle',
          component: () => import('@/views/material/article/index.vue'),
          meta: { title: 'menu.material.article.list', keepAlive: false },
          hideChildrenInMenu: true,
          children: [
            {
              path: '/material/article/form',
              name: 'materialArticleAdd',
              component: () => import('@/views/material/article/add.vue'),
              meta: { title: 'menu.material.article.add' }
            },
            {
              path: '/material/article/detail/:id',
              name: 'materialArticleDetail',
              component: () => import('@/views/material/article/detail.vue'),
              meta: { title: 'menu.material.article.detail' }
            },
            {
              path: '/material/article/form/:id',
              name: 'materialArticleEdit',
              component: () => import('@/views/material/article/edit.vue'),
              meta: { title: 'menu.material.article.edit' }
            }
          ]
        },
        {
          path: '/material/index',
          name: 'materialIndex',
          hideChildrenInMenu: true,
          component: () => import('@/views/material/template/index.vue'),
          meta: { title: 'menu.material.index', keepAlive: false }
        }
      ]
    },
    {
      path: '/quotation',
      name: 'quotation',
      component: () => import('@/layouts/RouteView.vue'),
      redirect: '/quotation/model',
      meta: { title: 'menu.quotation.title', icon: 'iconfont icon-gongyingshang-baojiajilu' },
      children: [
        {
          path: '/quotation/model',
          name: 'quotationModel',
          hideChildrenInMenu: true,
          component: () => import('@/views/quotation/model/index.vue'),
          meta: { title: 'menu.quotation.model', keepAlive: false }
        },
        {
          path: '/quotation/record',
          name: 'quotationRecord',
          component: () => import('@/views/quotation/record/index.vue'),
          meta: { title: 'menu.quotation.record', keepAlive: false },
          hideChildrenInMenu: true,
          children: [
            {
              path: '/quotation/record/detail',
              name: 'quotationRecordDetail',
              component: () => import('@/views/quotation/record/detail.vue'),
              meta: { title: 'menu.quotation.recordDetail' }
            }
          ]
        }
      ]
    },
    {
      path: '/consultation',
      name: 'consultation',
      component: () => import('@/views/consultation/index.vue'),
      meta: { title: 'menu.consultation.management', icon: 'iconfont icon-yonghu', keepAlive: false },
      hideChildrenInMenu: true,
      children: [
        {
          path: '/consultation/add',
          name: 'consultationAdd',
          component: () => import('@/views/consultation/add.vue'),
          meta: { title: 'menu.consultation.add' }
        },
        {
          path: '/consultation/detail/:id',
          name: 'consultationDetail',
          component: () => import('@/views/consultation/detail.vue'),
          meta: { title: 'menu.consultation.detail' }
        }
      ]
    },
    {
      path: '/user',
      name: 'user',
      component: () => import('@/views/userModel/index.vue'),
      meta: { title: 'menu.user.management', icon: 'iconfont icon-jiaoseguanli', keepAlive: true },
      hideChildrenInMenu: true,
      children: [
        {
          path: '/user/detail/:id',
          name: 'userDetail',
          component: () => import('@/views/userModel/detail.vue'),
          meta: { title: 'menu.user.managementDetail' }
        }
      ]
    },
    {
      path: '/character',
      name: 'character',
      component: () => import('@/views/character/index.vue'),
      hideChildrenInMenu: true,
      meta: { title: 'menu.system.character', icon: 'iconfont icon-shuju', keepAlive: true }
    },
    {
      path: '/dictionary',
      name: 'dictionary',
      component: () => import('@/views/dictionary/index.vue'),
      hideChildrenInMenu: true,
      meta: { title: 'menu.system.dictionary', icon: 'iconfont icon-zidianmokuai', keepAlive: true }
    },

    // exception
    {
      path: '/exception',
      name: 'exception',
      component: RouteView,
      redirect: '/exception/403',
      meta: { title: 'menu.exception.title', icon: 'bx-analyse' },
      hidden: true,
      children: [
        {
          path: '/exception/403',
          name: '403',
          component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/403.vue'),
          meta: { title: 'menu.exception.not-permission' }
        },
        {
          path: '/exception/404',
          name: '404',
          component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404.vue'),
          meta: { title: 'menu.exception.not-find' }
        },
        {
          path: '/exception/500',
          name: '500',
          component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/500.vue'),
          meta: { title: 'menu.exception.server-error' }
        }
      ]
    }
  ]
}
